export default __webpack_public_path__ + "static/media/user-badge-avatar.79cab3b8.svg";